var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect7, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectivePushUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 149,
    viewBox: "0 0 278 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 63.9062,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-4 129 63.9062)",
    fill: "#F55D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.516 103.783L151.414 83.3898L149.979 93.7459L155.339 100.928",
    stroke: "#24284E",
    strokeWidth: 8.61539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.414 102.002L159.711 101.701",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.522 112.979L188.169 107.269",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.28,
    cy: 76.6923,
    r: 6.46154,
    transform: "rotate(-4 162.28 76.6923)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.262 91.3682L176.562 95.6654",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.968 96.2666L167.667 91.9694",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.264 93.6672L176.262 91.3683L178.561 93.3667",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.669 94.2684L167.968 96.2667L169.966 93.9679",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.933,
    y: 62.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 127.933 62.9784)",
    stroke: "#FBEEE5",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28.9307,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-3 48 28.9307)",
    fill: "#F55D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8216 68.5486L70.07 48.8029L68.4545 59.1323L73.6886 66.4068",
    stroke: "#24284E",
    strokeWidth: 8.61539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7451 67.4824L78.0469 67.257",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6689 77.6035L106.403 73.32",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.0526,
    cy: 42.2962,
    r: 6.46154,
    transform: "rotate(-3 81.0526 42.2962)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7744 57.2139L94.9999 61.5157",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3965 61.9668L86.171 57.665",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7367 59.478L94.7749 57.2144L97.0385 59.2526",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1334 59.9282L86.397 61.9664L88.4352 59.7028",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.949,
    y: 27.9844,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 46.949 27.9844)",
    stroke: "#FBEEE5",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.9062,
    y: 1,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 98.9062 1)",
    fill: "#F55D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0134 38.473L118.391 23.4139L115.528 33.4695L119.837 41.3277",
    stroke: "#24284E",
    strokeWidth: 8.61539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.761 42.4014L124.058 42.7019",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8174 46.4668L151.464 52.1761",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.083,
    cy: 18.294,
    r: 6.46154,
    transform: "rotate(4 130.083 18.294)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.887 34.7725L141.586 39.0697",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.991 38.4688L133.292 34.1716",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.587 36.7707L141.886 34.7723L143.884 37.0712",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.993 36.1698L132.991 38.4686L135.29 36.4702",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97.9784,
    y: -0.0673205,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 97.9784 -0.0673205)",
    stroke: "#FBEEE5",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11322_9735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.681,
    y: 38,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 178.681 38)",
    fill: "#F55D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.43 68.8521L194 58.3301L190.952 66.7571L194.166 73.7338",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.038 74.6475L197.694 75.1613",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09 75.1367L220.561 84.9002",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.305,
    cy: 54.6509,
    r: 5.53846,
    transform: "rotate(8 204.305 54.6509)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.411 69.4473L212.897 73.1036",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.585 72.0752L206.099 68.4188",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.326 71.0176L213.411 69.4464L214.982 71.5315",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.014 69.9902L205.585 72.0753L207.67 70.504",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 177.83,
    y: 36.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 177.83 36.8706)",
    stroke: "#FBEEE5",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11322_9735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.5088,
    y: 63,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(9 92.5088 63)",
    fill: "#F55D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7229 93.511L107.471 83.594L104.276 91.9665L107.368 98.9983",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.224 99.9102L110.87 100.488",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2744 99.6504L133.565 110.625",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.838,
    cy: 80.0955,
    r: 5.53846,
    transform: "rotate(9 117.838 80.0955)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.685 95.0488L126.107 98.6957",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.813 97.54L119.391 93.8932",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.573 96.5832L126.685 95.0486L128.219 97.1608",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.279 95.4276L118.814 97.5398L120.926 96.0052",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.6775,
    y: 61.8559,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 91.6775 61.8559)",
    stroke: "#FBEEE5",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11322_9735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 10,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F55D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.462 40.4615L165.5 26.5L163.808 34.5385L167.616 40.4615",
    stroke: "#24284E",
    strokeWidth: 6.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.615 41.3076H171",
    stroke: "#24284E",
    strokeWidth: 5.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.692 47.2305H193",
    stroke: "#24284E",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.385,
    cy: 21.8465,
    r: 5.07692,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.538 34.1152V37.4998",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.77 37.5V34.1154",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.846 35.8075L184.538 34.1152L186.23 35.8075",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.077 35.8077L177.769 37.5L179.462 35.8077",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 148.083,
    y: 9.08333,
    width: 45.8333,
    height: 45.8333,
    rx: 22.9167,
    stroke: "#FBEEE5",
    strokeWidth: 1.83333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 91C58 89.8954 58.8954 89 60 89H80.2654C81.2607 89 82.1046 89.7319 82.2453 90.7172L85.7547 115.283C85.8954 116.268 86.7393 117 87.7346 117H188.265C189.261 117 190.105 116.268 190.245 115.283L193.755 90.7172C193.895 89.7319 194.739 89 195.735 89H216C217.105 89 218 89.8954 218 91V117V143C218 144.105 217.105 145 216 145H186H90H60C58.8954 145 58 144.105 58 143V117V91Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 129.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 62.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 34.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 6.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.5,
    cy: 111.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 3.5,
    r: 1.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 30 149)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17L40.5 25",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 98L38.5 91",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220 21L243 13.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238 73.5L256.5 78",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9735"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 63.9062,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-4 129 63.9062)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9735"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28.9307,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-3 48 28.9307)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9735"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.9062,
    y: 1,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 98.9062 1)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11322_9735"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.681,
    y: 38,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 178.681 38)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11322_9735"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.5088,
    y: 63,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(9 92.5088 63)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11322_9735"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 10,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectivePushUps);
export default __webpack_public_path__ + "static/media/collective-push-ups.bbcfe547534b05b71d68c6351b7350cd.svg";
export { ForwardRef as ReactComponent };